export enum AppNotification {
  GeneralError = 'Something went wrong, please contact support if the error persists.',
  AddPurchaseSuccess = 'Your purchase has been added.',
  AddPurchaseFailure = 'Something went wrong adding your purchase.',
  RequestPurchaseEligibilitySuccess = 'Your purchase has been submitted for review.',
  RequestPurchaseEligibilityFailure = 'Something went wrong submitting your purchase for review. Please contact support (info@joon.io) if error persists.',
  AddPurchaseAccountSuccess = 'Your purchase account has been added.',
  AddPurchaseAccountFailure = 'Something went wrong adding your purchase account.',
  CountryNotSupported = 'JOON does not currently support your country for purchase account connection. Please upload your receipts manually.',
  RelinkPurchaseAccountFailure = 'Something went wrong reauthorizing of your purchase account.',
  RelinkPurchaseAccountExitFailure = 'You exited the purchase account authorization flow.',
  RelinkPurchaseAccountSuccess = 'Reauthorized purchase account.',
  RemovePurchaseAccountFailure = 'Something went wrong removing of your purchase account.',
  RemovePurchaseAccountSuccess = 'Removed purchase account.',
  DepositAccountLinkFail = 'Something went wrong redirecting you to Stripe.',
  AddDepositAccountFailure = 'Something went wrong adding your deposit account.',
  AddDepositAccountSuccess = 'Your deposit account has been added.',
  ChangePasswordSuccess = 'Your password has been changed.',
  ChangePasswordFailure = 'Something went wrong changing your password.',
  MfaEnrolledSuccess = 'MFA has been enabled on your account.',
  MfaEnrollFailure = 'Something went wrong enabling MFA.',
  MfaVerifyFailure = 'The verification code was invalid. Please try again.',
  MfaDisabledSuccess = 'MFA has been disabled.',
  MfaDisableFailure = 'Something went wrong disabling MFA.',
  BackupCodesGenerateFailure = 'Something went wrong generating your backup codes.',
  BackupCodesConfirmFailure = 'Something went wrong saving your backup codes.',
  BackupCodesCopied = 'Backup codes copied to clipboard.',
  BackupCodeVerifyFailure = 'That backup code is invalid or has already been used.',
  UpdateUserDetailsSuccess = 'User details have been updated.',
  UpdateUserDetailsFailure = 'Something went wrong updating user details.',
  SetUserNotificationPreferencesSuccess = 'Your notification preferences have been updated.',
  SetUserNotificationPreferencesFailure = 'Something went wrong changing your notification preferences.',
  RemovePaymentAccountSuccess = 'Your payment account has been removed.',
  RemovePaymentAccountFailure = 'Something went wrong removing your payment account.',
  AddPaymentAccountFailure = 'Something went wrong adding your payment account.',
  TurnOnAutopaySuccess = 'Automatic payments have been enabled.',
  TurnOnAutopayFailure = 'Something went wrong enabling automatic payments.',
  TurnOffAutopaySuccess = 'Automatic payments have been disabled.',
  TurnOffAutopayFailure = 'Something went wrong disabling automatic payments.',
  SubmitInvoicePaymentSuccess = 'Payment successfully submitted.',
  SubmitInvoicePaymentFailure = 'Something went wrong submitting the payment.',
  UserActivateSuccess = 'User added to programs.',
  UserActivateFailed = 'Issue adding user to programs.',
  UserRemovalSuccess = 'User Removed.',
  UserRemovalFailed = 'Issue removing user.',
  UserInformationUpdatedSuccessful = 'User information updated.',
  UserPermissionsUpdatedSuccessful = 'User permissions updated.',
  ResetPasswordLinkSent = 'If you have a valid account with JOON, an email has been sent to you. Please check your email and follow the steps to reset your password.',
  ResetPasswordSuccess = 'Password has been reset successfully.',
  UserInviteSuccess = 'User invitation has been sent.',
  UserInviteFailure = 'Something went wrong when sending the invite.',
  CsvUserInviteSuccess = 'CSV invites has been processed',
  CsvUserInviteFailure = 'Something went wrong with CSV invites.',
  CsvUserUpdateMetaDataSuccess = 'Bulk user metadata has been successfully processed.',
  CsvUserUpdateMetaDataFailure = 'An error has occurred while processing the bulk update of user metadata.',
  BulkUserManagementSuccess = 'Bulk user management has been successfully processed.',
  BulkUserManagementFailure = 'An error has occurred while processing bulk user management.',
  DownloadTemplateFailure = 'Failed to download CSV template.',
  PurchaseInvalidationSuccess = 'Purchase invalidated.',
  InvoiceDownloadSuccess = 'Invoice downloaded.',
  CheckinReportGenerationSuccess = 'Check-in report data is being generated and will be emailed to you.',
  CheckinReportGenerationFailure = 'Something went wrong generating the check-in report data.',
  ReportDownloadSuccess = 'Report request queued. It will be emailed to you shortly.',
  ReportDownloadFailure = 'Report request failed to queue.',
  ReportSyncDownloadSuccess = 'Report downloaded successfully.',
  ReportSyncDownloadFailure = 'Failed to download report.',
  InvoiceDownloadFailure = 'Something went wrong downloading the invoice.',
  AllowanceModificationUpdateSuccess = 'Allowance successfully updated.',
  AllowanceModificationUpdateFailure = 'Something went wrong updating the policy.',
  ApproveManualPurchaseSuccess = 'Purchase successfully approved.',
  ApproveManualPurchaseFailure = 'Something went wrong approving this purchase.',
  DeclineManualPurchaseSuccess = 'Purchase successfully declined.',
  DeclineManualPurchaseFailure = 'Something went wrong declining this purchase.',
  RequestAdditionalReviewSuccess = 'Purchase sent for additional review.',
  RequestAdditionalReviewFailure = 'Something went wrong sending this purchase for additional review.',
  ResetOprSuccess = 'OPR reset.',
  ResetOprFailure = 'Something went wrong resetting the OPR.',
  AddInvoiceSuccess = 'Preparing Invoice... Refresh in a few minutes.',
  AddInvoiceFailure = 'Something went wrong adding this invoice.',
  AddMerchantSuccess = 'Merchant added.',
  AddMerchantFailure = 'Something went wrong adding this merchant.',
  DeleteInvoiceSuccess = 'Invoice deleted.',
  DeleteInvoiceFailure = 'Something went wrong deleting this invoice.',
  DeleteStripeAccountSuccess = 'Stripe account deleted.',
  DeleteStripeAccountFailure = "Something went wrong deleting user's stripe account.",
  FinalizeInvoiceSuccess = 'Invoice state changed to open.',
  FinalizeInvoiceFailure = 'Something went wrong finalizing this invoice.',
  MarkInvoiceCompleteSuccess = 'Invoice state changed to complete.',
  MarkInvoiceCompleteFailure = 'Something went wrong marking this invoice as complete.',
  GenerateStripeInvoiceSuccess = 'Stripe invoice generated.',
  GenerateStripeInvoiceFailure = 'Something went wrong generating this invoice.',
  RemoveStripeInvoiceIdSuccess = 'Stripe Invoice ID removed successfully.',
  RemoveStripeInvoiceIdFailure = 'Something went wrong removing the Stripe Invoice ID.',
  ResolveStripeRequirementsFailure = 'Something went wrong resolving your Stripe requirements.',
  RevertInvoiceToDraftSuccess = 'Invoice reverted to draft.',
  RevertInvoiceToDraftFailure = 'Something went wrong reverting this invoice to draft.',
  RunInvoiceAutopaySuccess = 'Invoice paid using auto-pay.',
  RunInvoiceAutopayFailure = 'Something went wrong charging for this invoice.',
  AssociateStripeInvoiceSuccess = 'Stripe Invoice ID saved.',
  AssociateStripeInvoiceFailure = 'Something went wrong updating this invoice.',
  UpdateUserCountrySuccess = 'User country successfully updated.',
  UpdateUserCountryFailure = 'Something went wrong updating user country.',
  RemoveUserFromProgramSuccess = 'Successfully updated eligibility dates for user.',
  RemoveUserFromProgramFailure = 'Failed to update user eligibility dates. Please contact support.',
  CreateBenefitProgramSuccess = 'Benefit program successfully created.',
  CreateBenefitProgramFailure = 'Something went wrong creating this benefit program.',
  UpdateBenefitProgramSuccess = 'Benefit program successfully updated.',
  UpdateBenefitProgramFailure = 'Something went wrong updating this benefit program.',
  UpdateBenefitProgramPolicySuccess = 'Benefit program policy successfully updated.',
  UpdateBenefitProgramPolicyFailure = 'Something went wrong updating this benefit program policy.',
  RemoveMerchantFromListSuccess = 'Merchant was successfully removed from the list.',
  RemoveMerchantFromListFailure = 'Something went wrong removing the merchant from the list.',
  AddProgramToMerchantSuccess = 'Merchant was successfully associated with program.',
  AddProgramToMerchantFailure = 'Something went wrong adding merchant to the list.',
  ExtendConnectionSuccess = 'Successfully reconfirmed purchase card connection.',
  ExtendConnectionFailure = 'Something went wrong reconfirming purchase card connection.',
  InviteNotFound = 'Invite not found. Please contact your admin.',
  ResetRenewDateSuccess = 'User purchase account connection renewal date updated.',
  ResetRenewDateFailure = 'Something went wrong updating user purchase account connection.',
  TerminateEmployerSuccess = 'Successfully terminated employer.',
  TerminateEmployerFailure = 'Something went wrong terminating employer.',
  ResendPendingInvitesNone = 'No pending invites to resend.',
  ResendPendingInvitesFailure = 'Something went wrong resending invites.',
  BenefitProgramReceiptDownloadSuccess = 'Request to download receipts successfully processed',
  BenefitProgramReceiptDownloadFailure = 'Something went wrong requesting receipt downloads.',
  PayWithPrepaidInvoiceSuccess = 'Request to use prepaid invoice was successful!',
  PayWithPrepaidInvoiceFailure = 'Request to use prepaid invoice failed!',
  AccountUnlockedSuccess = 'User account unlocked.',
  AccountUnlockedFailure = 'Something went wrong unlocking user account.',
  GenericSuccess = 'Success!',
  GenericFailure = 'Something went wrong.',
  CreateEmployerSuccess = 'Employer successfully created.',
  CreateEmployerFailure = 'Something went wrong creating this employer.',
  CreateEmployerCountrySuccess = 'Country successfully created.',
  CreateEmployerCountryFailure = 'Something went wrong creating this country.',
  DeleteEmployerCountrySuccess = 'Country successfully deleted.',
  DeleteEmployerCountryFailure = 'Something went wrong deleting this country.',
  CreateFeeScheduleSuccess = 'Fee schedule added.',
  CreateFeeScheduleFailure = 'Something went wrong adding this fee schedule.',
  UpdateFeeScheduleSuccess = 'Fee schedule updated.',
  UpdateFeeScheduleFailure = 'Something went wrong updating this fee schedule.',
  DeleteFeeScheduleSuccess = 'Fee schedule deleted.',
  DeleteFeeScheduleFailure = 'Something went wrong deleting this fee schedule.',
  CreateMetaFieldSuccess = 'Metadata field added.',
  CreateMetaFieldFailure = 'Something went wrong adding this metadata field.',
  UpdateMetaFieldSuccess = 'Metadata field updated.',
  UpdateMetaFieldFailure = 'Something went wrong updating this metadata field.',
  DeleteMetaFieldSuccess = 'Metadata field deleted.',
  DeleteMetaFieldFailure = 'Something went wrong deleting this metadata field.',
  UpdatePricingDescriptionSuccess = 'Pricing description updated.',
  UpdatePricingDescriptionFailure = 'Something went wrong updating the pricing description.',
  StripeInvoiceLinkFailure = 'Something went wrong redirecting you to your Stripe invoice.',
  AssociateMerchantCategorySuccess = 'Category associated successfully',
  AssociateMerchantCategoryFailure = 'Failed to associate category',
  DisassociateMerchantCategorySuccess = 'Category disassociated successfully',
  DisassociateMerchantCategoryFailure = 'Failed to disassociate category',
  BulkInvoiceGenerationSuccess = 'Bulk invoice generation started. You will receive a Slack notification when complete.',
  BulkInvoiceGenerationFailure = 'Something went wrong starting bulk invoice generation.',
  ReceiptLoadFailure = 'Unable to load receipt.',
  RefreshTransactionsSuccess = 'Transaction refresh requested.',
  RefreshTransactionsFailure = 'Something went wrong refreshing transactions.',
  ForceUpdateModeSuccess = 'Transaction account forced into update mode.',
  ForceUpdateModeFailure = 'Force update mode may not have completed; check the account and retry.',
  AddPurchaseForUserSuccess = 'Purchase successfully created for user.',
  AddPurchaseForUserFailure = 'Something went wrong adding purchase for user.',
  BulkCreatePurchasesSuccess = 'Purchases added successfully.',
  BulkCreatePurchasesFailure = 'An error occurred while uploading bulk purchases.',
  CreateJoonCategorySuccess = 'Category created.',
  CreateJoonCategoryFailure = 'Something went wrong creating this category.',
  UpdateJoonCategorySuccess = 'Category updated.',
  UpdateJoonCategoryFailure = 'Something went wrong updating this category.',
  DeleteJoonCategorySuccess = 'Category deleted.',
  DeleteJoonCategoryFailure = 'Something went wrong deleting this category.',
  AssociatePlaidCategorySuccess = 'Plaid category associated.',
  AssociatePlaidCategoryFailure = 'Something went wrong associating this plaid category.',
  DisassociatePlaidCategorySuccess = 'Plaid category disassociated.',
  DisassociatePlaidCategoryFailure = 'Something went wrong disassociating this plaid category.'
}
